module.exports = __webpack_public_path__ + "img/view_device_c1_two_en.1efeb43c.png";